/* eslint-disable no-console */

export async function unregisterServiceWorkers() {
  if (typeof window === "undefined") return;

  const tasks = [];

  // 1. Unregister all existing service workers
  if (
    "serviceWorker" in navigator &&
    navigator.serviceWorker.getRegistrations
  ) {
    tasks.push(
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          return Promise.all(
            registrations.map((registration) => {
              return registration
                .unregister()
                .then((success) => {
                  if (success) {
                    console.log(
                      "Service worker unregistered successfully:",
                      registration.scope
                    );
                  }
                  return success;
                })
                .catch((error) => {
                  console.error("Error unregistering service worker:", error);
                });
            })
          );
        })
        .catch((error) => {
          console.error(
            "Error retrieving service worker registrations:",
            error
          );
        })
    );
  }

  // 2. Delete all service worker / Workbox caches from CacheStorage
  if ("caches" in window && window.caches.keys) {
    tasks.push(
      window.caches
        .keys()
        .then((cacheNames) => {
          return Promise.all(
            cacheNames.map((cacheName) => {
              console.log("Deleting cache:", cacheName);
              return window.caches.delete(cacheName);
            })
          );
        })
        .catch((error) => {
          console.error("Error clearing CacheStorage:", error);
        })
    );
  }

  return Promise.all(tasks);
}

// Automatically invoke on app startup
unregisterServiceWorkers();
